import React, { ReactNode } from "react";
import styled from "styled-components";
import { Link } from "react-static";
import em from "polished/lib/helpers/em";
import { getLinkTarget } from "@flow/utils/cleaners";

const Button = styled.span`
  display: block;
  a {
    font-family: Flow-Inverted;
    text-transform: uppercase;
    font-size: 2.8em;
    display: block;
    white-space: nowrap;
    padding: ${em(2, 2.8)} ${em(2, 2.8)} ${em(1.4, 2.8)};
    border: ${em(0.1, 2.8)} solid ${(props) => props.theme.highlightColor};
    border-radius: ${em(3, 2.8)};

    &: ${(props) => props.theme.hoverProperty} {
      background-color: ${(props) => props.theme.highlightColor};
    }

    @media (max-width: 1300px) {
      font-size: ${28 / (1300 * 0.01)}vw;
    }

    @media (max-width: ${(props) => props.theme.twoColToOneColLayout}px) {
      font-size: 2.8em;
    }

    @media (max-width: 700px) {
      font-size: ${28 / (700 * 0.01)}vw;
    }

    @media (max-width: 480px) {
      font-size: 1.9em;
    }

    &.active {
      background-color: ${(props) => props.theme.highlightColor};
    }
  }

  &.smaller-text {
    a {
      font-size: 2.4em;
    }
  }

  &.google-signin,
  &.apple-signin {
    margin: 0 1.6em;

    a {
      text-decoration: none;
    }
  }

  &.google-signin {
    a {
      color: ${(props) => props.theme.default};
      border: ${em(0.1, 2.8)} solid ${(props) => props.theme.default};

      &: ${(props) => props.theme.hoverProperty} {
        color: ${(props) => props.theme.default};
        background-color: ${(props) => props.theme.highlightColor};
        border: ${em(0.1, 2.8)} solid ${(props) => props.theme.default};
      }

      &.active {
        background-color: ${(props) => props.theme.default};
      }
    }
  }

  &.apple-signin {
    a {
      color: ${(props) => props.theme.white};
      border: ${em(0.1, 2.8)} solid ${(props) => props.theme.white};
      background-color: ${(props) => props.theme.default};

      &: ${(props) => props.theme.hoverProperty} {
        color: ${(props) => props.theme.default};
        background-color: ${(props) => props.theme.highlightColor};
        border: ${em(0.1, 2.8)} solid ${(props) => props.theme.default};
      }

      &.active {
        background-color: ${(props) => props.theme.white};
      }
    }
  }
`;

// ToDo: merge this component with BasicButton

interface Props {
  label: string | ReactNode;
  href?: string;
  target?: string;
  onClick?(): void;
  exact?: boolean;
  buttonClassName?: string;
}

const LinkButton = ({
  label,
  href,
  target,
  onClick,
  exact = false,
  buttonClassName = "",
}: Props) => {
  function handleClick() {
    if (!onClick) {
      return;
    }
    onClick();
  }

  if (href) {
    return (
      <Button className={buttonClassName}>
        <Link to={href} target={getLinkTarget(target)} exact={exact}>
          {label}
        </Link>
      </Button>
    );
  } else {
    return (
      <Button className={buttonClassName}>
        <a onClick={handleClick}>{label || ""}</a>
      </Button>
    );
  }
};

export default LinkButton;



// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/components/ui/button/LinkButton.tsx